import React, { useRef, useState } from "react";
import { Column, MasterDetail, Button } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaListadoMaestros } from "../../../Componentes/Compuestos/Paginas/PaginaListadoMaestros";
import ABM_EEX_Clientes_Detalle from "./ABM_EEX_Clientes_Detalle";
import LVButtonAgregar from "../../../Componentes/Basicos/LVButtonAgregar";
import LVButtonReporte from "../../../Componentes/Basicos/LVButtonReporte";
import { function_ABM_EEX_Clientes_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const ABM_EEX_Clientes_ = () => {
  const [data, setData] = useState([])
  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_Listar } } = require('neftis7_apicaller');
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      
      const setData = async () => {
        try {
          await function_ABM_EEX_Clientes_Eliminar(Item.IdCliente)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  return (
    <PaginaListadoMaestros
      Titulo="CLIENTES"
      funcion={function_ABM_EEX_Clientes_Listar}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonAgregar Url="/ABM_EEX_Clientes_ModificacionCreacion/--NUEVO--" />
          <LVButtonReporte Url="/ABM_Reporte_EEX_Clientes_Cumpleanos" Texto="CUMPLEAÑOS DE CLIENTES" />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            id="gridContainer"
            keyExpr="IdCliente"
            urlEdicion="/ABM_EEX_Clientes_ModificacionCreacion"
            AnchoBotonera="65"
          >
            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={true} />
            </Column>

            <Column caption="Código" dataField="IdCliente" width="80" alignment="Right" dataType="number" />
            <Column caption="Razón Social" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            <Column caption="C.U.I.T." dataField="CUIT" width="120" alignment="Left" dataType="string" />
            <Column caption="Nombre Fantasía" dataField="NombreFantasia" width="150" alignment="Left" dataType="string" />

            <Column caption="Contacto" alignment="Center">
              <Column caption="Direcciones" dataField="Direcciones" width="250" alignment="Left" dataType="string" />
              <Column caption="Teléfonos" dataField="Telefonos" width="150" alignment="Left" dataType="string" />
              <Column caption="E-Mails" dataField="Emails" width="200" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Puntos" dataField="PuntosAcumulados" width="80" alignment="Right" dataType="number" />
            <Column caption="Lím. Aviso" dataField="LimiteCreditoAviso" width="80" alignment="Right" dataType="number" format="currency" />
            <Column caption="Lím. Corte" dataField="LimiteCreditoCorte" width="80" alignment="Right" dataType="number" format="currency" />
            <Column caption="Últ. Compra" dataField="FechaUltimaCompra" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            <Column caption="Zona" dataField="Zona" width="110" alignment="Left" dataType="string" />

            <Column caption="Tipo I.V.A." alignment="Center">
              <Column caption="Código" dataField="IdTipoIVA" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="ABM_IMP_TiposIVA_Descripcion" width="110" alignment="Left" dataType="string" />
            </Column>

            <Column caption="C. Contable" alignment="Center">
              <Column caption="Código" dataField="CodigoCuentaContableDefault" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="ABM_CON_CuentasContables_Descripcion" width="150" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Doc. Venta" alignment="Center">
              <Column caption="Código" dataField="IdTipoDocVentaDefault" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="VEN_DocsVenta_Tipos_Descripcion" width="110" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Vendedor" alignment="Center">
              <Column caption="Código" dataField="IdProfesionalVendedorAsignado" width="80" alignment="Right" dataType="number" />
              <Column caption="Razón Social" dataField="ABM_EEX_Profesionales_RazonSocial" width="110" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Condición de Venta" alignment="Center">
              <Column caption="Código" dataField="CodigoCondicionVenta" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="ABM_CON_CondicionesVenta_Descripcion" width="110" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Lista de Precios" alignment="Center">
              <Column caption="Código" dataField="CodigoListaPrecios" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="VEN_ListasPrecios_Cabecera_Descripcion" width="110" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Estado" alignment="Center">
              <Column caption="Código" dataField="IdEstado" width="80" alignment="Right" dataType="number" visible={false} />
              <Column caption="Descripción" dataField="TODOS_Estados_Descripcion" width="110" alignment="Left" dataType="string" />
            </Column>

            <MasterDetail
              enabled={true}
              component={ABM_EEX_Clientes_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListadoMaestros>
  );
};
